"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { ScrollArea as ScrollAreaPrimitive } from "radix-ui";
import { cn } from "@/shared/lib/utils";
function ScrollArea(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("relative", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = <ScrollAreaPrimitive.Viewport data-slot="scroll-area-viewport" className="focus-visible:ring-ring/50 size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:outline-1">{children}</ScrollAreaPrimitive.Viewport>;
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ScrollBar />;
    t4 = <ScrollAreaPrimitive.Corner />;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props || $[11] !== t1 || $[12] !== t2) {
    t5 = <ScrollAreaPrimitive.Root data-slot="scroll-area" className={t1} {...props}>{t2}{t3}{t4}</ScrollAreaPrimitive.Root>;
    $[10] = props;
    $[11] = t1;
    $[12] = t2;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function ScrollBar(t0) {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ScrollAreaPrimitive.ScrollAreaThumb data-slot="scroll-area-thumb" className="bg-border relative flex-1 rounded-full" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== orientation || $[8] !== props || $[9] !== t2) {
    t4 = <ScrollAreaPrimitive.ScrollAreaScrollbar data-slot="scroll-area-scrollbar" data-orientation={orientation} orientation={orientation} className={t2} {...props}>{t3}</ScrollAreaPrimitive.ScrollAreaScrollbar>;
    $[7] = orientation;
    $[8] = props;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export { ScrollArea, ScrollBar };